import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FileText, Download, ChevronDown } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
interface DocItem {
  name: string;
  type: string;
  size: string;
  url: string;
}
interface DocCategory {
  title: string;
  items: DocItem[];
}
interface SubLine {
  name: string;
  categories: DocCategory[];
}
interface ProductLine {
  id: string;
  name: string;
  logo: string | null;
  categories?: DocCategory[];
  subLines?: SubLine[];
}
export function DownloadsPage() {
  const {
    t
  } = useLanguage();
  const [openSections, setOpenSections] = useState<Record<string, boolean>>({
    SmartFloor: true,
    SmartPanel: true,
    SmartDoor: true,
    SmartStrips: true,
    SmartSofa: true,
    SmartMachinery: true,
    SmartGarden: true,
    General: true
  });
  const toggleSection = (id: string) => {
    setOpenSections(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };
  const productLines: ProductLine[] = [{
    id: 'SmartFloor',
    name: 'SmartFloor',
    logo: 'https://cdn.magicpatterns.com/uploads/doKdWE88fwcLzdXFibFDGA/Captura_de_pantalla_2025-02-05_101948-removebg-preview.png',
    categories: [{
      title: t('prod.docs.catalogs'),
      items: [{
        name: t('dl.floor.cat1'),
        type: 'PDF',
        size: '8.5 MB',
        url: 'https://drive.google.com/uc?export=download&id=1rWzjnj_XxpG9ZI41Dv4ZklwnkjUOVHIu'
      }, {
        name: t('dl.floor.cat2'),
        type: 'PDF',
        size: '12.1 MB',
        url: 'https://drive.google.com/uc?export=download&id=1rx5l0D3CiLPa9YYLxGzaFy6xNQLa_Q6p'
      }]
    }, {
      title: t('prod.docs.techSheets'),
      items: [{
        name: t('dl.sec1.i1'),
        type: 'PDF',
        size: '1.2 MB',
        url: 'https://drive.google.com/uc?export=download&id=1KVTl6tHOlv1BFGEjPlqcMXhPpaxvrgLB'
      }, {
        name: t('dl.sec1.i4'),
        type: 'PDF',
        size: '1.8 MB',
        url: 'https://drive.google.com/uc?export=download&id=1P4KgIx6CR4fs4qCXed9ucR73zExC7dvt'
      }, {
        name: t('dl.sec1.i5'),
        type: 'PDF',
        size: '1.5 MB',
        url: 'https://drive.google.com/uc?export=download&id=1RCsWIgwO08R1nnM2GLA0y_7McZ8wQHp2'
      }]
    }, {
      title: t('dl.cat.guides'),
      items: [{
        name: t('dl.sec2.i2'),
        type: 'PDF',
        size: '—',
        url: ''
      }]
    }, {
      title: t('dl.cat.certs'),
      items: [{
        name: t('dl.sec3.i1'),
        type: 'PDF',
        size: '0.8 MB',
        url: ''
      }, {
        name: t('dl.sec3.i3'),
        type: 'PDF',
        size: '0.5 MB',
        url: ''
      }]
    }]
  }, {
    id: 'SmartPanel',
    name: 'SmartPanel',
    logo: 'https://cdn.magicpatterns.com/uploads/pmx8tqFJe4duTghZHoM65P/WhatsApp_Image_2025-01-24_at_12.09.08__3_-removebg-preview-e1739973722182.png',
    subLines: [{
      name: 'SmartPanel PVC',
      categories: [{
        title: t('prod.docs.catalogs'),
        items: [{
          name: t('dl.panel.pvc.cat1'),
          type: 'PDF',
          size: '15.2 MB',
          url: 'https://drive.google.com/file/d/1zr8o2ejc-nEwgTB62OZIu_X_ayO2GWZK/view'
        }, {
          name: t('dl.panel.pvc.cat2'),
          type: 'PDF',
          size: '14.8 MB',
          url: 'https://drive.google.com/file/d/11_qZZR20t8PjtozmHmgo0r7NYOemQXcy/view'
        }, {
          name: t('dl.panel.pvc.cat3'),
          type: 'PDF',
          size: '11.4 MB',
          url: 'https://drive.google.com/file/d/19PoNWPk4VsYqRmInjwgSO1sAV4qpgVZj/view'
        }, {
          name: t('dl.panel.pvc.cat4'),
          type: 'PDF',
          size: '9.7 MB',
          url: 'https://drive.google.com/file/d/1B3zgsHzSHy_og0vWqzkg7TxdLTn34m_Q/view'
        }]
      }, {
        title: t('dl.cat.guides'),
        items: [{
          name: t('dl.sec2.i1'),
          type: 'PDF',
          size: '3.1 MB',
          url: ''
        }]
      }]
    }, {
      name: 'SmartPanel SPC',
      categories: [{
        title: t('prod.docs.catalogs'),
        items: [{
          name: t('dl.panel.spc.cat1'),
          type: 'PDF',
          size: '10.5 MB',
          url: 'https://drive.google.com/file/d/1oe1Ef-yW8F0_ohmeId5-LoxuRe9__-OP/view'
        }]
      }]
    }, {
      name: t('panel.bambu.name'),
      categories: [{
        title: t('prod.docs.catalogs'),
        items: [{
          name: t('dl.panel.bambu.cat1'),
          type: 'PDF',
          size: '8.2 MB',
          url: 'https://drive.google.com/file/d/1J0QkA1QOaTREaXyNeHt5wFfI1_2yjAy8/view'
        }]
      }]
    }, {
      name: t('dl.panel.piedra.name'),
      categories: [{
        title: t('prod.docs.catalogs'),
        items: [{
          name: t('dl.panel.piedra.cat1'),
          type: 'PDF',
          size: '—',
          url: ''
        }]
      }]
    }]
  }, {
    id: 'SmartDoor',
    name: 'SmartDoor',
    logo: 'https://cdn.magicpatterns.com/uploads/gg9vSbfbXeYE8Zpb8HjLum/WhatsApp_Image_2025-01-24_at_12.09.08-removebg-preview-e1739973429684.png',
    categories: [{
      title: t('prod.docs.catalogs'),
      items: [{
        name: t('dl.door.cat1'),
        type: 'PDF',
        size: '18.5 MB',
        url: 'https://drive.google.com/file/d/1cY9ruqc99fFkPyl7Yoo7qjkQmL7LZpUC/view'
      }]
    }, {
      title: t('prod.docs.techSheets'),
      items: [{
        name: t('dl.sec1.i2'),
        type: 'PDF',
        size: '2.4 MB',
        url: ''
      }]
    }, {
      title: t('dl.cat.guides'),
      items: [{
        name: t('dl.sec2.i3'),
        type: 'PDF',
        size: '—',
        url: ''
      }]
    }]
  }, {
    id: 'SmartStrips',
    name: 'SmartStrips',
    logo: null,
    categories: [{
      title: t('prod.docs.catalogs'),
      items: [{
        name: t('dl.strips.cat1'),
        type: 'PDF',
        size: '—',
        url: ''
      }]
    }]
  }, {
    id: 'SmartSofa',
    name: 'SmartSofa',
    logo: null,
    categories: [{
      title: t('prod.docs.catalogs'),
      items: [{
        name: t('dl.sofa.cat1'),
        type: 'PDF',
        size: '—',
        url: ''
      }]
    }]
  }, {
    id: 'SmartMachinery',
    name: 'SmartMachinery',
    logo: null,
    categories: [{
      title: t('prod.docs.catalogs'),
      items: [{
        name: t('dl.machinery.cat1'),
        type: 'PDF',
        size: '—',
        url: ''
      }]
    }]
  }, {
    id: 'SmartGarden',
    name: 'SmartGarden',
    logo: null,
    categories: [{
      title: t('prod.docs.catalogs'),
      items: [{
        name: t('dl.garden.cat1'),
        type: 'PDF',
        size: '—',
        url: ''
      }]
    }]
  }, {
    id: 'General',
    name: t('dl.general.name'),
    logo: null,
    categories: [{
      title: t('dl.cat.certs'),
      items: [{
        name: t('dl.sec3.i2'),
        type: 'PDF',
        size: '1.1 MB',
        url: ''
      }]
    }]
  }];
  // Reusable document row renderer
  const renderDocRow = (item: DocItem, itemIdx: number) => <div key={itemIdx} className="flex flex-col sm:flex-row sm:items-center justify-between p-4 rounded-md hover:bg-gray-50 transition-colors duration-300 group" data-id="element-235">
      <div className="flex items-center mb-4 sm:mb-0" data-id="element-236">
        <FileText className="h-5 w-5 text-gray-400 mr-4 flex-shrink-0" data-id="element-237" />
        <span className="text-base font-medium text-gray-700 group-hover:text-corporate-dark transition-colors" data-id="element-238">
          {item.name}
        </span>
      </div>
      <div className="flex items-center justify-between sm:justify-end sm:space-x-6 w-full sm:w-auto" data-id="element-239">
        <span className="bg-gray-100 text-gray-500 px-3 py-1 rounded-full font-semibold text-xs tracking-wider uppercase" data-id="element-240">
          {item.type}
        </span>
        {item.url ? <a href={item.url} target="_blank" rel="noopener noreferrer" download className="inline-flex items-center justify-center px-4 py-2 border border-corporate-blue text-corporate-blue hover:bg-corporate-blue hover:text-white transition-all duration-300 rounded-md font-medium text-sm ml-4" data-id="element-241">
            <Download className="mr-2 h-4 w-4" data-id="element-242" />
            {t('dl.btn')}
          </a> : <span className="inline-flex items-center justify-center px-4 py-2 border border-gray-200 text-gray-400 bg-gray-50 rounded-md font-medium text-sm ml-4 cursor-default" data-id="element-243">
            <Download className="mr-2 h-4 w-4" data-id="element-244" />
            {t('dl.btn')}
          </span>}
      </div>
    </div>;
  // Render categories (flat list)
  const renderCategories = (categories: DocCategory[]) => <div className="space-y-10" data-id="element-245">
      {categories.map((category, catIdx) => <div key={catIdx} data-id="element-246">
          <h3 className="text-sm uppercase tracking-wider text-gray-400 font-semibold mb-4 border-b border-gray-100 pb-2" data-id="element-247">
            {category.title}
          </h3>
          <div className="space-y-2" data-id="element-248">
            {category.items.map((item, itemIdx) => renderDocRow(item, itemIdx))}
          </div>
        </div>)}
    </div>;
  // Render subLines (SmartPanel specific)
  const renderSubLines = (subLines: SubLine[]) => <div className="space-y-8" data-id="element-249">
      {subLines.map((sub, subIdx) => <div key={subIdx} className="border border-gray-100 rounded-md overflow-hidden" data-id="element-250">
          <div className="bg-gray-50/70 px-6 py-4 border-b border-gray-100" data-id="element-251">
            <h3 className="text-lg font-heading font-semibold text-corporate-dark" data-id="element-252">
              {sub.name}
            </h3>
          </div>
          <div className="p-6 space-y-8" data-id="element-253">
            {sub.categories.map((category, catIdx) => <div key={catIdx} data-id="element-254">
                <h4 className="text-xs uppercase tracking-wider text-gray-400 font-semibold mb-3 border-b border-gray-50 pb-2" data-id="element-255">
                  {category.title}
                </h4>
                <div className="space-y-1" data-id="element-256">
                  {category.items.map((item, itemIdx) => renderDocRow(item, itemIdx))}
                </div>
              </div>)}
          </div>
        </div>)}
    </div>;
  return <div className="w-full bg-neutral-grey min-h-screen pb-32" data-id="element-257">
      {/* Hero Section */}
      <div className="bg-corporate-dark text-white py-20 md:py-32 px-4" data-id="element-258">
        <div className="max-w-7xl mx-auto text-center mt-10" data-id="element-259">
          <motion.h1 initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: [0.25, 0.1, 0.25, 1]
        }} className="text-5xl md:text-6xl font-heading font-bold mb-6 tracking-tight" data-id="element-260">
            {t('dl.hero.title')}
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2,
          duration: 0.8,
          ease: [0.25, 0.1, 0.25, 1]
        }} className="text-xl text-gray-300 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-261">
            {t('dl.hero.desc')}
          </motion.p>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 -mt-12 relative z-10" data-id="element-262">
        <div className="space-y-8" data-id="element-263">
          {productLines.map((line, idx) => {
          const isOpen = openSections[line.id];
          return <motion.div key={line.id} initial={{
            opacity: 0,
            y: 40
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3 + idx * 0.1,
            duration: 0.8,
            ease: [0.25, 0.1, 0.25, 1]
          }} className="bg-white rounded-sm shadow-md hover:shadow-lg transition-shadow duration-500 ease-premium overflow-hidden border border-gray-100" data-id="element-264">
                {/* Accordion Header */}
                <button onClick={() => toggleSection(line.id)} className="w-full bg-gray-50 px-8 py-6 border-b border-gray-100 flex items-center justify-between hover:bg-gray-100 transition-colors duration-300" data-id="element-265">
                  <div className="flex items-center" data-id="element-266">
                    {line.logo ? <img src={line.logo} alt={line.name} className="h-8 md:h-10 w-auto object-contain" data-id="element-267" /> : <h2 className="text-2xl font-heading font-bold text-corporate-dark" data-id="element-268">
                        {line.name}
                      </h2>}
                  </div>
                  <ChevronDown className={`h-6 w-6 text-gray-400 transition-transform duration-300 ${isOpen ? 'rotate-180' : 'rotate-0'}`} data-id="element-269" />
                </button>

                {/* Accordion Body */}
                <AnimatePresence initial={false} data-id="element-270">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.4,
                ease: [0.25, 0.1, 0.25, 1]
              }} className="overflow-hidden" data-id="element-271">
                      <div className="p-8" data-id="element-272">
                        {line.subLines ? renderSubLines(line.subLines) : line.categories ? renderCategories(line.categories) : null}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </div>;
}